module.exports = __webpack_public_path__ + "img/shot_tx19122402.ac8bf22b.jpg";